<div class="main-content">
	<div class="container-fluid">
		<mat-card class="feature-surface">
			<mat-card-header>
				<div mat-card-avatar class="feature-surface__icon">
					<i class="material-icons" aria-hidden="true">redeem</i>
				</div>
				<mat-card-title>Promo &amp; Intro Performance</mat-card-title>
				<mat-card-subtitle>
					Invoiced deal sales — units, list value and sale value
				</mat-card-subtitle>
			</mat-card-header>
			<mat-card-content>

				<form [formGroup]="filterForm" class="row mb-2">
					<div class="col-6 col-md-2">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>From</mat-label>
							<input matInput type="date" formControlName="from">
						</mat-form-field>
					</div>
					<div class="col-6 col-md-2">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>To</mat-label>
							<input matInput type="date" formControlName="to">
						</mat-form-field>
					</div>
					<div class="col-6 col-md-2">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Brand</mat-label>
							<mat-select formControlName="brand" multiple appSelectAll>
								<mat-option *ngFor="let b of brands" [value]="b.code">{{ b.name }}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="col-6 col-md-2">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Salesman</mat-label>
							<mat-select formControlName="salesman" multiple appSelectAll>
								<mat-option *ngFor="let s of salesmen" [value]="s.code">{{ s.name }}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="col-6 col-md-2">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Branch</mat-label>
							<mat-select formControlName="branch" (selectionChange)="load()">
								<mat-option value="">All</mat-option>
								<mat-option *ngFor="let b of branches" [value]="b.code">{{ b.code }} · {{ b.name }}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="col-6 col-md-2">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Customer</mat-label>
							<input matInput [formControl]="customerSearch" [matAutocomplete]="autoCustomer"
								placeholder="Name or account #" autocomplete="off">
							<mat-autocomplete #autoCustomer="matAutocomplete"
								(optionSelected)="pickCustomer($event.option.value)">
								<mat-option *ngFor="let c of customerResults" [value]="c">
									<strong>{{ c.debtorno }}</strong> — {{ c.name }}
								</mat-option>
							</mat-autocomplete>
							<mat-spinner matSuffix diameter="18" *ngIf="customerSearching"></mat-spinner>
							<button matSuffix mat-icon-button type="button" *ngIf="customer && !customerSearching"
								(click)="clearCustomer()" aria-label="Clear customer filter">
								<i class="material-icons" aria-hidden="true">close</i>
							</button>
						</mat-form-field>
					</div>
				</form>

				<div class="d-flex mb-2 flex-wrap align-items-center" style="gap: 8px;">
					<button mat-flat-button [color]="view === 'promos' ? 'accent' : ''" (click)="setView('promos')">Promos</button>
					<button mat-flat-button [color]="view === 'customers' ? 'accent' : ''" (click)="setView('customers')">Customers</button>

					<span class="flex-grow-1"></span>

					<mat-form-field appearance="outline" class="promo-quick-search">
						<mat-label>Quick search</mat-label>
						<input matInput type="search" autocomplete="off" [formControl]="searcher">
						<i matSuffix class="material-icons" aria-hidden="true">search</i>
					</mat-form-field>

					<button mat-stroked-button color="accent" (click)="load()">Apply</button>

					<button mat-icon-button (click)="exportXls()" [disabled]="exporting || !hasExportableRows"
						matTooltip="Export to Excel" aria-label="Export to Excel">
						<i class="material-icons" aria-hidden="true">grid_on</i>
					</button>
					<button mat-icon-button (click)="exportPdf()" [disabled]="exporting || !hasExportableRows"
						matTooltip="Export to PDF" aria-label="Export to PDF">
						<i class="material-icons" aria-hidden="true">picture_as_pdf</i>
					</button>
					<mat-progress-spinner *ngIf="exporting" diameter="20" mode="indeterminate" color="accent">
					</mat-progress-spinner>
				</div>


				<div *ngIf="errorMessage" class="feature-section mb-3">
					<p class="feature-section__title m-0">{{ errorMessage }}</p>
				</div>

				<div *ngIf="loading" class="text-center my-4">
					<mat-progress-spinner diameter="32" mode="indeterminate" color="accent"></mat-progress-spinner>
				</div>

				<!-- ============================ PROMOS ============================ -->
				<ng-container *ngIf="!loading && view === 'promos'">

					<div class="feature-tile-row" *ngIf="displayTotals">
						<app-kpi-tile tone="accent" label="deals" [value]="displayTotals.deals | number"></app-kpi-tile>
						<app-kpi-tile tone="accent" label="units" [value]="displayTotals.units | number"></app-kpi-tile>
						<app-kpi-tile tone="accent" label="list value"
							[value]="'$' + (displayTotals.list_value | number:'1.0-0')"></app-kpi-tile>
						<app-kpi-tile tone="settled" label="sale value"
							[value]="'$' + (displayTotals.net_sales | number:'1.0-0')"></app-kpi-tile>
					</div>

					<p *ngIf="searching" class="text-muted mt-2 mb-1" style="font-size: 12px;">
						showing {{ searchresults.length }} of {{ rows.length }}
					</p>

					<div #printTable>
					<div class="feature-table-scroll">
					<table class="feature-table feature-table--responsive">
						<thead>
							<tr>
								<th class="promo-expand-col noprint"></th>
								<th><button class="sort-head" (click)="sortBy('promo')">SKU <i class="material-icons" aria-hidden="true">{{ sortIcon('promo') }}</i></button></th>
								<th>Description</th>
								<th><button class="sort-head" (click)="sortBy('brand')">Brand <i class="material-icons" aria-hidden="true">{{ sortIcon('brand') }}</i></button></th>
								<th>Type</th>
								<th class="is-num"><button class="sort-head" (click)="sortBy('deals')">Deals <i class="material-icons" aria-hidden="true">{{ sortIcon('deals') }}</i></button></th>
								<th class="is-num"><button class="sort-head" (click)="sortBy('units')">Units <i class="material-icons" aria-hidden="true">{{ sortIcon('units') }}</i></button></th>
								<th class="is-num"><button class="sort-head" (click)="sortBy('list')">List <i class="material-icons" aria-hidden="true">{{ sortIcon('list') }}</i></button></th>
								<th class="is-num"><button class="sort-head" (click)="sortBy('net')">Sale <i class="material-icons" aria-hidden="true">{{ sortIcon('net') }}</i></button></th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let r of searchresults">
								<tr>
									<td class="promo-expand-col noprint">
										<button mat-icon-button (click)="openPromo(r)"
											[attr.aria-expanded]="isExpanded(r)"
											[attr.aria-label]="'Detail for ' + r.promo_sku">
											<i class="material-icons" aria-hidden="true">
												{{ isExpanded(r) ? 'expand_less' : 'expand_more' }}
											</i>
										</button>
									</td>
									<td data-label="SKU">{{ r.promo_sku }}</td>
									<td data-label="Description">{{ r.promo_name }}</td>
									<td data-label="Brand">{{ r.brand_name }}</td>
									<td data-label="Type">{{ dealType(r) }}</td>
									<td data-label="Deals" class="is-num">{{ r.deals | number }}</td>
									<td data-label="Units" class="is-num">{{ r.component_units | number }}</td>
									<td data-label="List" class="is-num">{{ r.list_value | currency }}</td>
									<td data-label="Sale" class="is-num">{{ r.net_sales | currency }}</td>
								</tr>

								<!-- Detail for this deal, in its own row directly under it. -->
								<tr *ngIf="isExpanded(r)" class="promo-detail-row donotprint noprint">
									<td colspan="9">
										<div class="feature-section">
											<div class="d-flex justify-content-between align-items-center flex-wrap mb-2" style="gap: 8px;">
												<p class="feature-section__title m-0">{{ r.promo_sku }} — {{ r.promo_name }}</p>
												<span class="d-flex align-items-center flex-wrap" style="gap: 8px;">
													<mat-form-field appearance="outline" class="promo-quick-search promo-quick-search--drill">
														<mat-label>Search</mat-label>
														<input matInput type="search" autocomplete="off" [formControl]="drillSearcher">
														<i matSuffix class="material-icons" aria-hidden="true">search</i>
													</mat-form-field>
													<button mat-stroked-button [color]="drill === 'orders' ? 'accent' : ''"
														(click)="showOrders()">Invoices</button>
													<button mat-stroked-button [color]="drill === 'components' ? 'accent' : ''"
														(click)="showComponents()">Contents</button>
													<button mat-icon-button (click)="closeDrill()" aria-label="Close detail">
														<i class="material-icons" aria-hidden="true">close</i>
													</button>
												</span>
											</div>

											<div *ngIf="componentsLoading || ordersLoading" class="text-center my-3">
												<mat-progress-spinner diameter="28" mode="indeterminate" color="accent"></mat-progress-spinner>
											</div>

											<div class="feature-table-scroll mt-3"
												*ngIf="drill === 'orders' && !ordersLoading">
												<table class="feature-table feature-table--responsive">
													<thead>
														<tr>
															<th>Date</th>
															<th>Type</th>
															<th>Trans #</th>
															<th>Order #</th>
															<th>Account</th>
															<th>Customer</th>
															<th>Loc</th>
															<th>Rep</th>
															<th class="is-num">Deals</th>
															<th class="is-num">Units</th>
															<th class="is-num">List</th>
															<th class="is-num">Sale</th>
														</tr>
													</thead>
													<tbody>
														<tr *ngFor="let o of orderResults">
															<td data-label="Date">{{ o.trandate | date:'MM/dd/yy' }}</td>
															<td data-label="Type">{{ o.type == 11 ? 'CRN' : 'INV' }}</td>
															<td data-label="Trans #">{{ o.transno }}</td>
															<td data-label="Order #">{{ o.orderno }}</td>
															<td data-label="Account">{{ o.debtorno }}</td>
															<td data-label="Customer">{{ o.customer }}</td>
															<td data-label="Loc">{{ o.loccode }}</td>
															<td data-label="Rep">{{ o.salesman_name }}</td>
															<td data-label="Deals" class="is-num">{{ o.deals | number }}</td>
															<td data-label="Units" class="is-num">{{ o.component_units | number }}</td>
															<td data-label="List" class="is-num">{{ o.list_value | currency }}</td>
															<td data-label="Sale" class="is-num">{{ o.net_sales | currency }}</td>
														</tr>
														<tr *ngIf="!orderResults.length">
															<td colspan="12" class="text-center text-muted">
																{{ drillSearching ? 'no invoices match that search' : 'no invoices in this range' }}
															</td>
														</tr>
													</tbody>
												</table>
											</div>

											<div class="feature-table-scroll mt-3"
												*ngIf="drill === 'components' && !componentsLoading">
												<table class="feature-table feature-table--responsive">
													<thead>
														<tr>
															<th>SKU</th>
															<th>Description</th>
															<th>Line</th>
															<th class="is-num">Units</th>
															<th class="is-num">List</th>
															<th class="is-num">Sale</th>
														</tr>
													</thead>
													<tbody>
														<tr *ngFor="let c of componentResults">
															<td data-label="SKU">{{ c.stockid }}</td>
															<td data-label="Description">{{ c.description }}</td>
															<td data-label="Line">{{ c.is_header == 1 ? 'Header' : 'Component' }}</td>
															<td data-label="Units" class="is-num">{{ c.units | number:'1.0-2' }}</td>
															<td data-label="List" class="is-num">{{ c.list_value | currency }}</td>
															<td data-label="Sale" class="is-num">{{ c.net_sales | currency }}</td>
														</tr>
														<tr *ngIf="!componentResults.length">
															<td colspan="6" class="text-center text-muted">
																{{ drillSearching ? 'no lines match that search' : 'no lines in this range' }}
															</td>
														</tr>
														<tr *ngIf="displayComponentTotals && componentResults.length" class="is-total">
															<td data-label="SKU">Total</td>
															<td></td>
															<td></td>
															<td data-label="Units" class="is-num">{{ displayComponentTotals.units | number:'1.0-2' }}</td>
															<td data-label="List" class="is-num">{{ displayComponentTotals.list_value | currency }}</td>
															<td data-label="Sale" class="is-num">{{ displayComponentTotals.net_sales | currency }}</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</td>
								</tr>
							</ng-container>

							<tr *ngIf="!searchresults.length && !errorMessage">
								<td colspan="9" class="text-center text-muted">
									{{ searching ? 'no rows match that search' : 'no deals invoiced in this range' }}
								</td>
							</tr>
							<tr *ngIf="displayTotals && searchresults.length" class="is-total">
								<td class="promo-expand-col noprint"></td>
								<td data-label="SKU">Total</td>
								<td></td>
								<td></td>
								<td></td>
								<td data-label="Deals" class="is-num">{{ displayTotals.deals | number }}</td>
								<td data-label="Units" class="is-num">{{ displayTotals.units | number }}</td>
								<td data-label="List" class="is-num">{{ displayTotals.list_value | currency }}</td>
								<td data-label="Sale" class="is-num">{{ displayTotals.net_sales | currency }}</td>
							</tr>
						</tbody>
					</table>
					</div>
					</div>
				</ng-container>

				<!-- =========================== CUSTOMERS =========================== -->
				<ng-container *ngIf="!loading && view === 'customers'">

					<div class="feature-tile-row" *ngIf="displayTotals">
						<app-kpi-tile tone="accent" label="customers" [value]="displayTotals.rows | number"></app-kpi-tile>
						<app-kpi-tile tone="accent" label="deals" [value]="displayTotals.deals | number"></app-kpi-tile>
						<app-kpi-tile tone="accent" label="list value"
							[value]="'$' + (displayTotals.list_value | number:'1.0-0')"></app-kpi-tile>
						<app-kpi-tile tone="settled" label="sale value"
							[value]="'$' + (displayTotals.net_sales | number:'1.0-0')"></app-kpi-tile>
					</div>

					<p *ngIf="searching" class="text-muted mt-2 mb-1" style="font-size: 12px;">
						showing {{ searchresults.length }} of {{ rows.length }}
					</p>

					<div #printTable>
					<div class="feature-table-scroll">
					<table class="feature-table feature-table--responsive">
						<thead>
							<tr>
								<th>Account</th>
								<th><button class="sort-head" (click)="sortBy('customer')">Customer <i class="material-icons" aria-hidden="true">{{ sortIcon('customer') }}</i></button></th>
								<th>Branch</th>
								<th><button class="sort-head" (click)="sortBy('rep')">Rep <i class="material-icons" aria-hidden="true">{{ sortIcon('rep') }}</i></button></th>
								<th class="is-num"><button class="sort-head" (click)="sortBy('promos')">Promos <i class="material-icons" aria-hidden="true">{{ sortIcon('promos') }}</i></button></th>
								<th class="is-num"><button class="sort-head" (click)="sortBy('deals')">Deals <i class="material-icons" aria-hidden="true">{{ sortIcon('deals') }}</i></button></th>
								<th class="is-num"><button class="sort-head" (click)="sortBy('units')">Units <i class="material-icons" aria-hidden="true">{{ sortIcon('units') }}</i></button></th>
								<th class="is-num"><button class="sort-head" (click)="sortBy('list')">List <i class="material-icons" aria-hidden="true">{{ sortIcon('list') }}</i></button></th>
								<th class="is-num"><button class="sort-head" (click)="sortBy('net')">Sale <i class="material-icons" aria-hidden="true">{{ sortIcon('net') }}</i></button></th>
								<th><button class="sort-head" (click)="sortBy('last')">Last sold <i class="material-icons" aria-hidden="true">{{ sortIcon('last') }}</i></button></th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let r of searchresults">
								<td data-label="Account">{{ r.debtorno }}</td>
								<td data-label="Customer">{{ r.customer }}</td>
								<td data-label="Branch">{{ r.branchcode }}</td>
								<td data-label="Rep">{{ r.salesman_name }}</td>
								<td data-label="Promos" class="is-num">{{ r.promos_bought | number }}</td>
								<td data-label="Deals" class="is-num">{{ r.deals | number }}</td>
								<td data-label="Units" class="is-num">{{ r.component_units | number }}</td>
								<td data-label="List" class="is-num">{{ r.list_value | currency }}</td>
								<td data-label="Sale" class="is-num">{{ r.net_sales | currency }}</td>
								<td data-label="Last sold">{{ r.last_sold | date:'MM/dd/yy' }}</td>
							</tr>
							<tr *ngIf="!searchresults.length && !errorMessage">
								<td colspan="10" class="text-center text-muted">
									{{ searching ? 'no rows match that search' : 'no deals invoiced in this range' }}
								</td>
							</tr>
							<tr *ngIf="displayTotals && searchresults.length" class="is-total">
								<td data-label="Account">Total</td>
								<td></td>
								<td></td>
								<td></td>
								<td></td>
								<td data-label="Deals" class="is-num">{{ displayTotals.deals | number }}</td>
								<td data-label="Units" class="is-num">{{ displayTotals.units | number }}</td>
								<td data-label="List" class="is-num">{{ displayTotals.list_value | currency }}</td>
								<td data-label="Sale" class="is-num">{{ displayTotals.net_sales | currency }}</td>
								<td></td>
							</tr>
						</tbody>
					</table>
					</div>
					</div>
				</ng-container>

				<p *ngIf="truncated" class="text-muted mt-2" style="font-size: 12px;">
					First {{ limit | number }} rows shown — narrow the filters or export for the full set.
				</p>

			</mat-card-content>
		</mat-card>
	</div>
</div>
